import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { RequireRole, RequireMember, HomeRedirect } from "@/components/RequireRole";
import ManagerLayout from "@/components/layout/ManagerLayout";
import LocksmithLayout from "@/components/layout/LocksmithLayout";
import Login from "@/pages/Login";
import SetPassword from "@/pages/SetPassword";
import ForgotPassword from "@/pages/ForgotPassword";
import AcceptInvite from "@/pages/AcceptInvite";
import Home from "@/pages/Home";
import Dashboard from "@/pages/manager/Dashboard";
import Runs from "@/pages/manager/Runs";
import RunForm from "@/pages/manager/RunForm";
import Locksmiths from "@/pages/manager/Locksmiths";
import LocksmithEditPage from "@/pages/manager/LocksmithEditPage";
import Officers from "@/pages/manager/Officers";
import PreWarrantVisits from "@/pages/manager/PreWarrantVisits";
import { PreWarrantVisitForm } from "@/pages/manager/PreWarrantVisits";
import { PreWarrantVisitDetail } from "@/pages/manager/PreWarrantVisits";
import LockChanges from "@/pages/manager/LockChanges";
import MapPage from "@/pages/manager/MapPage";
import MortiseLocks from "@/pages/MortiseLocks";
import Billing from "@/pages/manager/Billing";
import Companies from "@/pages/manager/Companies";
import PlatformMemberEditPage from "@/pages/manager/PlatformMemberEditPage";
import Plans from "@/pages/manager/Plans";
import Partners from "@/pages/Partners";
import Signup from "@/pages/Signup";
import Features from "@/pages/Features";
import FeaturePage from "@/pages/FeaturePage";
import Profile from "@/pages/Profile";
import VerifyEmail from "@/pages/VerifyEmail";
import MyJobs from "@/pages/locksmith/MyJobs";
import AvailableJobs from "@/pages/locksmith/AvailableJobs";
import RunDetail from "@/pages/RunDetail";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/features/:slug" element={<FeaturePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/runs/:id" element={<RequireMember><RunDetail /></RequireMember>} />
          <Route path="/reset-password" element={<SetPassword mode="reset" />} />
          <Route path="/manager" element={<RequireRole role="manager"><ManagerLayout /></RequireRole>}>
            <Route index element={<Dashboard />} />
            <Route path="runs" element={<Runs />} />
            <Route path="runs/new" element={<RunForm />} />
            <Route path="runs/:id" element={<RunDetail backTo="/manager/runs" isManager />} />
            <Route path="runs/:id/edit" element={<RunForm />} />
            <Route path="locksmiths" element={<Locksmiths />} />
            <Route path="locksmiths/:id/edit" element={<LocksmithEditPage />} />
            <Route path="pre-warrant-visits" element={<PreWarrantVisits />} />
            <Route path="pre-warrant-visits/new" element={<PreWarrantVisitForm />} />
            <Route path="pre-warrant-visits/:id" element={<PreWarrantVisitDetail isManager />} />
            <Route path="pre-warrant-visits/:id/edit" element={<PreWarrantVisitForm />} />
            <Route path="officers" element={<Officers />} />
            <Route path="lock-changes" element={<LockChanges />} />
            <Route path="map" element={<MapPage />} />
            <Route path="available" element={<AvailableJobs />} />
            <Route path="mortise-locks" element={<MortiseLocks />} />
            <Route path="partners" element={<Partners />} />
            <Route path="billing" element={<Billing />} />
            <Route path="admin" element={<Companies />} />
            <Route path="admin/members/:companyId/:memberId" element={<PlatformMemberEditPage />} />
            <Route path="owner-account" element={<Companies />} />
            <Route path="companies" element={<Companies />} />
            <Route path="plans" element={<Plans />} />
            <Route path="profile" element={<Profile />} />
          </Route>
          <Route path="/jobs" element={<RequireRole role="locksmith"><LocksmithLayout /></RequireRole>}>
            <Route index element={<MyJobs />} />
            <Route path="profile" element={<Profile />} />
            <Route path="available" element={<AvailableJobs />} />
            <Route path="map" element={<MapPage />} />
            <Route path="mortise-locks" element={<MortiseLocks />} />
            <Route path="partners" element={<Partners />} />
            <Route path="pre-warrant-visits" element={<PreWarrantVisits />} />
            <Route path="pre-warrant-visits/:id" element={<PreWarrantVisitDetail />} />
            <Route path=":id" element={<RunDetail backTo="/jobs" />} />
          </Route>
          <Route path="*" element={<HomeRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

export default App;
